import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import NO_OUT_Component from "../NO_OUT_Component";
import ResultHeader from "../../Table/ResultHeader";
import ResultBody from "../../Table/ResultBody";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";
import {useModal} from "../../../Context/ModalContext";
import StationElevationPlot from "../UI/StationElevationPlot";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B17({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {
    return (
        <>
            <StationElevationPlot
                crossSection={riverStation?.cross_section}
                plotData={{
                    base: riverStation?.plot_base,
                    cmp: riverStation?.plot_cmp
                }}
                globalVariables={globalVariables}
                layers={layers}
            />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.FCWSEL01.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return (
                <>
                    <ResultText>
                        The flow for the following profiles is not contained within the listed cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>Profile</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Cross Section</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>

                        <ResultBody>
                            {
                                profiles.map(p => {
                                    const cs_list = row.data.filter(x => x.profile === p)
                                    if(cs_list.length === 0) {
                                        return ''
                                    }

                                    return (
                                        <>
                                            <ResultRow>
                                                <ResultBodyCell>{p}</ResultBodyCell>
                                                <ResultBodyCell>
                                                    <CheckCSName csNameList={cs_list.map(x => x.cross_section)} />
                                                </ResultBodyCell>
                                            </ResultRow>
                                        </>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.B17_NOOUT01.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B17_NOOUT02.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}